module.exports = __webpack_public_path__ + "static/media/QRBG.9c26f723.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/shareImg/image/QRBG.png
// module id = 992
// module chunks = 0